














































































import {Component, Prop, Model} from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import {BusEvent} from '@/models/bus';

import Modal from '@/components/Modal.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import MetricName from "@/api/metricName";
import FieldInternational from "@/components/FieldInternational.vue";
import {InternationalizedField} from "@/api/common";

@Component({
    components: {
        'field-international': FieldInternational,
        'modal': Modal,
        'edit-icon': EditIcon,
    },
})
export default class FieldMetrics extends CommonVue {
    @Model('update') public metric_list!: InternationalizedField<string>[];
    @Prop({type: Boolean, default: false}) public disabled?: boolean;

    public metric_name: InternationalizedField<string> = null;
    public isNewWord: boolean = false;
    public showModal: boolean = false;

    // noinspection JSMethodCanBeStatic
    public edit(word: InternationalizedField<string>) {
        this.metric_name = word;
        this.isNewWord = false;
        this.showModal = true;
    }

    public newMetric() {
        this.metric_name = new InternationalizedField<string>();
        this.isNewWord = true;
        this.showModal = true;
    }

    public saveClicked() {
        if (!this.metric_name) {
            return;
        }

        this.busy = true;

        try {
            this.checkMandatoryFields();
            if (this.isNewWord) {
                this.metric_list.push(this.metric_name);
            }
            this.busy = false;
            this.showModal = false;
        } catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not save name', e);
        }
    }

    public checkMandatoryFields() {
        // Check if text is filled
        if(!this.metric_name || this.metric_name.en === '') {
            throw Error('Please insert the text for your metric name.');
        }
    }

    public deleteClicked() {
        const newList = this.metric_list.filter((value) => {
            return value !== this.metric_name;
        });

        this.$emit('update', newList);
        this.showModal = false;
    }
}

